// based on https://weblog.west-wind.com/posts/2014/Feb/22/Using-CSS-Transitions-to-SlideUp-and-SlideDown

import _ from 'underscore';

var baseClass = 'js-slider';
var openClass = 'js-slide-open';
var closedClass = 'js-slide-closed';
var animatingClass = 'js-slide-animating';

function initElements(elements) {
  elements.addClass(baseClass).addClass(closedClass);
}

function isAnimating(element) {
  return element.hasClass(animatingClass);
}

function slideDown(element) {
  // temporarily make visible to get the size
  element.removeClass(closedClass);
  var height = element.height() + 50;

  // reset to 0 then animate with small delay
  element.css({ 'max-height': '0' });
  element.addClass(animatingClass).addClass(openClass);

  _.delay(function () {
    element.css({ 'max-height': height + 'px' });
  }, 1);
  resetAll(element);
}

function slideUp(element) {
  element.removeClass(openClass).removeAttr('style').addClass(closedClass).addClass(animatingClass);
  resetAll(element);
}

function slideToggle(element) {
  element.hasClass(openClass) ? slideUp(element) : slideDown(element);
}

function resetAll(element, inline) {
  _.delay(function () {
    element.removeClass(animatingClass);
  }, 750);
}

export default {
  initElements,
  isAnimating,
  slideToggle,
  slideDown,
  slideUp,
};
